<template>
  <v-menu
    bottom
    left
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        v-show="notifications.length > 0"
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-badge
          :value="notifications.length"
          bordered
          color="red"
          overlap
        >
          <template v-slot:badge>
            <span>{{ notifications.length }}</span>
          </template>

          <v-icon>$notifications</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list
      flat
      nav
    >
      <app-bar-item
        v-for="(n, i) in notifications"
        :key="i"
        link
        @click="clickNotification"
      >
        <v-list-item-content
          @click="clickNotification(n)"
        >
          <v-list-item-title>{{ n.message }} </v-list-item-title>
        </v-list-item-content>
      </app-bar-item>
    </v-list>
  </v-menu>
</template>

<script>
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'DefaultNotifications',

    data: () => ({
      // notifications: [],
    }),
    computed: {
      // pusher_notifications: get('auth/notifications'),
      notifications: get('profile/notifications'),
    },
    watch: {
      /* pusher_notifications: {
        handler (val) {
          console.log(val)
          if (val) {
            this.load()
          }
        },
      }, */
    },
    mounted () {
      this.load()
    },
    methods: {
      getNotifications: call('profile/getNotifications'),
      setNotificationRead: call('profile/setNotificationRead'),
      async load () {
        await this.getNotifications({}).then(response => {
          // this.notifications = response
        }).catch(e => {
          this.loading = false
          // this.setSnackbar({ text: e, type: 'error' })
        })
      },
      async clickNotification (notification) {
        this.$router.push('/profile/notifications/' + notification.id).catch(() => {})
        /* await this.setNotificationRead({ id: notification.id }).then(response => {
          // this.notifications.splice(this.notifications.indexOf(notification), 1)
          this.$router.push('/profile/notifications').catch(() => {})
          // this.notifications.splice()
          // this.load()
        }).catch(e => {
          console.log(e)
        }) */
      },
    },
  }
</script>
